module.exports = __webpack_public_path__ + "img/mouse.2f254b0f.png";